(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");

    // 1. 处理 IntersectionObserver
    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();


    

    // 2. 初始化 Swiper，确保元素存在后再执行
    const swiperEl = document.querySelector('.announcement-bar__message.swiper');

    const autoplay = swiperEl.dataset.autoplay === 'true';
    const stopAutoplay = swiperEl.dataset.stopAutoplay === 'true';
    const delay = parseInt(swiperEl.dataset.delay) * 1000 || 3000;

    let autoplayParm = {}
    if (autoplay) {
        autoplayParm = {
            autoplay: {
                delay: delay,
                pauseOnMouseEnter: stopAutoplay,
                disableOnInteraction: false,
            },
        }
    }
    
    if (swiperEl) {
      new Swiper(swiperEl, {

        navigation: {
          nextEl: '.announcement-bar__message .next',
          prevEl: '.announcement-bar__message .prev',
        },
        slidesPerView: 1,
        loop: true,
        ...autoplayParm,
      });
    } else {
      console.warn('Swiper container not found');
    }
  };

  // 3. Shopify 事件绑定
  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  // 4. 初始执行
  window.addEventListener("load", initAnnBar);
})();
